module.exports = __webpack_public_path__ + "static/video-poster-891ec99cb0be57f8bb6dd0af40f5b0c6.jpg";